import { Link } from "react-router-dom";
import { usePageTitle } from "@/i18n/LanguageContext";
import { PlatformDemo } from "@/demo/PlatformDemo";
import { pages } from "../content/pages";
import { useContent, Rich } from "../ui/helpers";
import { PageShell, PageHero } from "../ui/blocks";
import { DigitalTwin } from "../twin/DigitalTwin";

/* ---------- /demo — digital twin + role views (both on sample data) ---------- */
export function DemoPage() {
  usePageTitle("demo");
  const c = useContent(pages).demo;
  return (
    <PageShell testId="demo-page">
      <PageHero hero={c.hero} />
      <DigitalTwin id="twin" />
      {/* Role views demo. Data: src/demo/data.js · views: src/demo/*View.jsx */}
      <div className="demo-host"><PlatformDemo /></div>
    </PageShell>
  );
}

/* ---------- /privacy ---------- */
export function PrivacyPage() {
  usePageTitle("privacy");
  const c = useContent(pages).privacy;
  const common = useContent(pages).common;
  return (
    <PageShell testId="privacy-page">
      <section className="contact" style={{ paddingBottom: 60 }}>
        <div className="k-wrap">
          <nav className="crumbs" aria-label={common.breadcrumb}><Link to="/">{common.home}</Link><span aria-hidden="true">/</span><span aria-current="page">{c.crumb}</span></nav>
          <p className="k-label">{c.eyebrow}</p>
          <h1>{c.title}</h1>
          <p className="lead">{c.intro}</p>
        </div>
      </section>
      <section className="band-light sec" style={{ paddingTop: 64 }}>
        <div className="k-wrap"><div className="legal">
          {c.sections.map(([h, p]) => <div key={h}><h2>{h}</h2><p>{p}</p></div>)}
          <p className="legal-date">{c.updated}</p>
        </div></div>
      </section>
    </PageShell>
  );
}

/* ---------- 404 ---------- */
export function NotFoundPage() {
  usePageTitle("notFound");
  const c = useContent(pages).notFound;
  return (
    <PageShell testId="not-found-page">
      <section className="contact" style={{ minHeight: "80vh", display: "flex", alignItems: "center" }}>
        <div className="k-wrap">
          <p className="k-label">404</p>
          <h1><Rich text={c.title} /></h1>
          <p className="lead">{c.body}</p>
          <p style={{ marginTop: 32 }}><Link className="k-btn k-btn-mint" to="/">{c.back} <span className="ar" aria-hidden="true">→</span></Link></p>
        </div>
      </section>
    </PageShell>
  );
}
